// hooks/useStudentGroups.js
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { studentService } from '../Services/studentService';
import { setSnackError } from '../Reducers/snackErrors';
import { handleApiError } from '../Utils/ApiErrorHandler';


/**
 * 
 * @returns 
 * 
 * This hook will be used for student groups.
 * 
 * Made a mistake this should be combined with useGetStudentGroups()
 * 
 * 
 */

export const useGetStudentAttendies = () => {
  const [student_attendies, setStudents] = useState([]);

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const fetchStudentsAttendies = async (group_id) => {
    if (!group_id) return null;

    setLoading(true);

    try {
      const data = await studentService.getStudentAttendies(group_id);
      setStudents(data);
      return data;
    } catch (error) {
      handleApiError(error, dispatch, "getting student attendies ")
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { 
    student_attendies, 
    loading,
    fetchStudentsAttendies 
  };
};